import { message } from "antd";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { useGetUserInfo, useValidateToken } from "./hooks/api/user/hooks";
import AppLayout from "./views/layout/layout";
import Login from "./views/pages/auth/Login";
import { Suspense, useEffect } from "react";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import SiteLoader from "./views/components/SiteLoader";
import { useAuthStore } from "./store/slices/user";

function App() {
  const { setUserInfo, userInfo } = useAuthStore();

  const { data, isLoading, isFetching, isError, error } = useValidateToken();
  const [messageApi, contextHolder] = message.useMessage();

  if (isError || error) {
    window.localStorage.clear();
    messageApi.error("Unauthorized. Login Again!!");
  }

  console.log("userInfo", userInfo);

  useEffect(() => {
    if (data?.data) {
      setUserInfo(data?.data);
    }
  }, [data?.data]);

  return (
    <NuqsAdapter>
      <BrowserRouter basename="/">
        {contextHolder}
        {isLoading || isFetching ? (
          <SiteLoader />
        ) : isError ? (
          <Login />
        ) : (
          <Suspense fallback={<SiteLoader />}>
            <AppLayout />
          </Suspense>
        )}
      </BrowserRouter>
    </NuqsAdapter>
  );
}

export default App;
